import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ClientTipsComponent} from './client-tips/client-tips.component';

@NgModule({
  declarations: [
    ClientTipsComponent
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    ClientTipsComponent
  ],
})
export class ClientTipModule {
}
